import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { BookOpen, LifeBuoy, PlayCircle, HelpCircle } from "lucide-react";
import { SUPPORT_EMAIL } from "../config";

const CARDS = [
  {
    icon: PlayCircle,
    title: "Product tour",
    body: "Two-minute click-through of the real workspace.",
    to: "/product-tour",
  },
  {
    icon: BookOpen,
    title: "Getting started",
    body: "Step-by-step first day: workspace, clients, calendar, first booking.",
    to: "/how-it-works",
  },
  {
    icon: HelpCircle,
    title: "FAQ",
    body: "The questions people ask us most often, answered plainly.",
    to: "/faq",
  },
  {
    icon: LifeBuoy,
    title: "Contact support",
    body: "Reach a real human. We reply within one business day.",
    to: "/contact",
  },
];

export default function Resources() {
  return (
    <>
      <SEO
        title="Resources"
        description="Get started with ClientDesk VA — product tour, walkthroughs, FAQ and direct support access."
        path="/resources"
      />
      <section className="pt-20 pb-8 bg-[#FAF7F2]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
              Resources
            </div>
            <h1 className="font-display font-extrabold text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.03em] text-[#1A2A3A] mb-5">
              Everything you need to get going.
            </h1>
            <p className="text-[17px] text-[#57534E] max-w-2xl mx-auto leading-relaxed">
              Product walkthroughs, a plain-English FAQ, and a direct line to
              real people when you need us.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 60}>
              <Link
                to={c.to}
                className="block p-7 rounded-2xl border border-[#E8E2D9] bg-[#FAF7F2] hover:border-[#E8712C]/40 transition-colors h-full"
              >
                <c.icon size={26} strokeWidth={1.6} className="text-[#E8712C] mb-4" />
                <div className="font-display font-bold text-[19px] text-[#1A2A3A] tracking-[-0.01em] mb-1">
                  {c.title}
                </div>
                <div className="text-[14px] text-[#57534E]">{c.body}</div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24 bg-white">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <p className="text-[14px] text-[#57534E]">
            Prefer email? Write to{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[#E8712C] font-medium hover:underline">
              {SUPPORT_EMAIL}
            </a>
            .
          </p>
        </div>
      </section>
    </>
  );
}
